import * as d3 from "d3";
import { Chart } from "@/utils/Chart";
import i18n from "../lang/lang";

export function ChartBarGroupedHorizontal(alias, chartData) {
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  var chart = new Chart(alias);

  this.render = function () {
    var y = d3
      .scaleBand()
      .range([0, chart.chartHeight])
      .padding(0.1)
      .domain(
        this.data.map(function (d) {
          return i18n.tc(d.label);
        })
      );

    var values = [];
    var keys = [];
    for (var i in this.data) {
      for (var j in this.data[i].group) {
        values.push(this.data[i].group[j].value);
        if (keys.indexOf(this.data[i].group[j].label) === -1) {
          keys.push(this.data[i].group[j].label);
        }
      }
    }

    var x = d3
      .scaleLinear()
      .domain([0, d3.max(values)])
      .range([0, chart.chartWidth]);

    var yIn = d3.scaleBand().domain(keys).range([0, y.bandwidth()]);

    var group = chart.svg.selectAll(".group").data(this.data);
    var newGroup = group.enter().append("g").attr("class", "group");

    group.merge(newGroup).attr("transform", (d) => {
      return "translate(" + [0, y(i18n.tc(d.label))] + ")";
    });

    var bar = newGroup.selectAll(".bar").data(function (d) {
      return d.group;
    });

    var newBar = bar.enter().append("g").append("rect").attr("class", "bar");

    var text = newGroup
      .selectAll("g")
      .append("text")
      .attr("transform", (d) => {
        return "translate(" + [0, yIn(d.label)] + ")";
      })
      .attr("font-size", chart.fontSize)
      .style("font-family", "Montserrat-Regular")
      .attr("dx", "0.3rem")
      .attr("dy", yIn.bandwidth() / 2 + 5)
      .text(function (d) {
        return chart.format(d);
      });

    text.transition(chart.transition).attr("transform", (d) => {
      return "translate(" + [x(d.value), yIn(d.label)] + ")";
    });

    bar
      .merge(newBar)
      .attr("width", 0)
      .attr("height", yIn.bandwidth())
      .attr("fill", (d) => {
        return chart.getColor(d.label);
      })
      .attr("transform", (d) => {
        return "translate(" + [0, yIn(d.label)] + ")";
      })
      .on("mouseover", function (d) {
        chart.openTooltip(i18n.tc(d.label) + ": " + d.value);
      })
      .on("mouseout", function () {
        chart.closeTooltip();
      })
      .on("mousemove", function () {
        var coordinates = d3.mouse(this);
        chart.moveTooltip(coordinates[0], coordinates[1] - 30);
      });

    bar
      .merge(newBar)
      .transition(chart.transition)
      .attr("width", (d) => {
        return x(d.value);
      })
      .attr("transform", (d) => {
        return "translate(" + [0, yIn(d.label)] + ")";
      });

    chart.drawAxis(x, y, this.chartData.xAxis, this.chartData.yAxis);
  };
}
